/**
 * Footer
 * 사이트 전체 공통 하단 영역.
 * - 후원 링크 (카카오페이 / PayPal)
 * - Powered by PickFlip / About / Contact
 *
 * PickFlip 뿐 아니라 다른 앱, 너풀너풀 스튜디오 홈페이지에서도
 * 이 파일을 그대로 복사해서 재사용하면 됩니다. (About/Contact 링크는
 * 프로젝트마다 다를 수 있으니 props로 넘기거나 필요시 직접 수정)
 *
 * 사용 예:
 * <Footer
 *   kakaopayLink="https://qr.kakaopay.com/FdBLYiRRE9c401556"
 *   paypalLink="https://www.paypal.com/paypalme/nuhpulnuhpul"
 *   productName="PickFlip"
 *   aboutHref="/about"
 *   contactEmail="hello@nuhpul.com"
 * />
 */
export default function Footer({
  kakaopayLink,
  paypalLink,
  productName = 'PickFlip',
  aboutHref = '/about',
  contactEmail = 'hello@nuhpul.com'
}) {
  const linkStyle = (color, weight = '700') => ({
    color,
    textDecoration: 'none',
    fontWeight: weight
  });

  const handleMouseOver = (e) => {
    e.currentTarget.style.textDecoration = 'underline';
  };

  const handleMouseOut = (e) => {
    e.currentTarget.style.textDecoration = 'none';
  };

  return (
    <>
      {/* 후원 안내 */}
      <div style={{
        marginTop: '60px',
        textAlign: 'center',
        color: '#7F8C8D',
        fontSize: '14px',
        fontWeight: '500'
      }}>
        <p style={{ margin: '12px 0 0 0', fontSize: '13px', fontWeight: '600' }}>
          ☕ Support us: {' '}
          <a
            href={kakaopayLink}
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle('#B8860B')}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
          >
            [카카오페이로 후원하기]
          </a>
          {' | '}
          <a
            href={paypalLink}
            target="_blank"
            rel="noopener noreferrer"
            style={linkStyle('#0070BA')}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
          >
            [Support via PayPal]
          </a>
        </p>
      </div>

      {/* Powered by / About / Contact */}
      <div style={{
        marginTop: '20px',
        textAlign: 'center',
        color: '#7F8C8D',
        fontSize: '14px',
        fontWeight: '500',
        paddingBottom: '20px'
      }}>
        <p style={{ margin: '5px 0' }}>
          Powered by <span style={{ fontWeight: '700', color: '#2C3E50' }}>{productName}</span>
          {' | '}
          <a
            href={aboutHref}
            style={linkStyle('#2C3E50', '600')}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
          >
            About
          </a>
          {' | '}
          <a
            href={`mailto:${contactEmail}`}
            style={linkStyle('#2C3E50', '600')}
            onMouseOver={handleMouseOver}
            onMouseOut={handleMouseOut}
          >
            Contact
          </a>
        </p>
      </div>
    </>
  );
}
